import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAdminPersonalDetailsLogic } from './hooks/useAdminPersonalDetailsLogic';
import { AdminPersonalDetailsForm } from './AdminPersonalDetailsForm';

export const AdminPersonalDetails = () => {
  const { t } = useTranslation('inviteTeamMember');
  const { formMethods, handleSubmit, isLoading } = useAdminPersonalDetailsLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        handleSubmit={handleSubmit}
        heading={t('accountantPersonalDetails.title')}
        formMethods={formMethods}
        customSubmitTitle={t('accountantPersonalDetails.acceptAndContinue')}
        footerInputSlot={<></>}
        isLoading={isLoading}
        shouldStrechCta>
        <AdminPersonalDetailsForm />
      </StepPageWrapper>
    </FormProvider>
  );
};

export default AdminPersonalDetails;
